import { ELIGIBLE_PLAYERS_REQUESTED, ELIGIBLE_TEAM_OFFICIALS_REQUESTED, EXTENDED_ELIGIBLE_PLAYERS_REQUESTED, EXTENDED_ELIGIBLE_TEAM_OFFICIALS_REQUESTED } from '../constants/actionTypes';

export const loadEligiblePlayers = ( context, token, gameId, teamId ) => {

    return {
        type:    ELIGIBLE_PLAYERS_REQUESTED,
        payload: { context, token, gameId, teamId }
    };

};

export const loadEligibleTeamOfficials = ( context, token, gameId, teamId ) => {

    return {
        type:    ELIGIBLE_TEAM_OFFICIALS_REQUESTED,
        payload: { context, token, gameId, teamId }
    };

};

export const loadExtendedEligiblePlayers = ( context, token, gameId, teamId ) => {

    return {
        type:    EXTENDED_ELIGIBLE_PLAYERS_REQUESTED,
        payload: { context, token, gameId, teamId }
    };

};

export const loadExtendedEligibleTeamOfficials = ( context, token, gameId, teamId ) => {

    return {
        type:    EXTENDED_ELIGIBLE_TEAM_OFFICIALS_REQUESTED,
        payload: { context, token, gameId, teamId }
    };

};